import { BaseModel, Guid, RecursivePartial } from '@models/base';
import { VzSystemLicenseModule } from './system-license-module';

export const VzSystemModuleName = ['task', 'chat', 'calendar', 'video'] as const;
export type TVzSystemModule = typeof VzSystemModuleName[number];
export const VzSystemModuleNameText: { [k in TVzSystemModule]: string } = {
    chat: 'Чаты',
    task: 'Задачи',
    video: 'Видеозвонки',
    calendar: 'Календарь'
};

export enum VzSystemLicenseType {
    Invalid     = 0,
    Permanent   = 1,
    Emergency   = 2,
    Temporary   = 3,
}
export const VzSystemLicenseTypeName = {
    [VzSystemLicenseType.Invalid]: 'Недействительная',
    [VzSystemLicenseType.Permanent]: 'Постоянная',
    [VzSystemLicenseType.Emergency]: 'Аварийная',
    [VzSystemLicenseType.Temporary]: 'Временная',
}

export class VzSystemLicense extends BaseModel {
    id?: Guid;
    created?: Date;
    expired?: Date;
    activeTill?: Date;
    maxUsers: number = 0;
    maxOrgs: number = 1;
    type: number = 0;
    modules: { [module in TVzSystemModule]?: VzSystemLicenseModule } = {};

    constructor(json?: RecursivePartial<VzSystemLicense>) {
        super(json);
        this.parseVzSystemLicense(json || {});
    }

    parse(json: RecursivePartial<VzSystemLicense>): VzSystemLicense {
        super.parse(json);
        this.parseVzSystemLicense(json);
        return this;
    }

    private parseVzSystemLicense(json: RecursivePartial<VzSystemLicense>): void {
        VzSystemLicense.assignFields(this, json, ['id', 'maxUsers', 'maxOrgs', 'type']);
        VzSystemLicense.assignDates(this, json, ['created', 'expired', 'activeTill']);
        VzSystemLicense.assignClassMaps(this, json, { modules: VzSystemLicenseModule });
    }
}
